import React from 'react';
import { useTranslations } from '../../../../../../shared/src/hooks/use-translations.hook';
import { ThumbnailFavoriteBadge } from '../../ThumbnailFavoriteBadge';
import {
    GtmEventLocation,
    GtmEventComponent,
    GtmEventClickElement
} from '../../../../../../shared/src/components/google-tag-manager/enums/gtm-event-enum';
import { GtmService } from '../../../../../../shared/src/services/gtm.service';
import { useCurrentVerticalData } from '../../../../../../shared/src/hooks/use-current-vertical-data.hook';

export const CasinoThumbnailOverlayStripsUI = ({
    overlayBadges,
    openGameHandler,
    showFavorites,
    name = '',
    ctaTextRef = null,
    gameId,
}) => {
    const {
        pamGameVerticalID,
        currentVerticalType,
    } = useCurrentVerticalData();
    const { t } = useTranslations();

    const tarckPlayGame = (clickAction) => {
        GtmService.track({
            location: GtmEventLocation.GAME_GRID,
            component: GtmEventComponent.GAMES_THUMBNAIL,
            click_element: GtmEventClickElement.BUTTON,
            click_action: clickAction,
            game_id: gameId,
            game_vertical_id: pamGameVerticalID,
            game_vertical_type: currentVerticalType,
        });
    };

    const handlePlayClick = () => {
        tarckPlayGame('open game');
        openGameHandler(gameId);
    };

    const showDemoPlay = Boolean(overlayBadges?.right);

    const handleDemoPlayClick = () => {
        tarckPlayGame('open demo game');
        overlayBadges.right.onClickHandler();
    };

    const displayName = !!name;

    return (
        <div className="casino-thumbnail__hover m-strip-grid-ui">
            <div className="casino-thumbnail__hover-mode-top">
                <div className="casino-thumbnail__hover-mode-fill"></div>

                {showFavorites && <ThumbnailFavoriteBadge gameId={gameId} />}
            </div>

            {displayName && <div className="casino-thumbnail__play-text"
                onClick={openGameHandler}
            >
                <span ref={ctaTextRef}>
                    {`${t('play')} ${name}`}
                </span>
            </div>}

            {!displayName && <div className="casino-thumbnail__hover-mode-cover">
                <div className="casino-thumbnail__hover-mode-buttons">
                    <button className="casino-thumbnail__hover-mode-btn casino-thumbnail__hover-mode-btn--play"
                        onClick={handlePlayClick}
                    >
                        {`${t('gameHoverPlayCta')}`}
                    </button>

                    {showDemoPlay && <button
                        className="casino-thumbnail__hover-mode-btn casino-thumbnail__hover-mode-btn--demo"
                        onClick={handleDemoPlayClick}
                    >
                        {`${t('gameHoverDemoCta')}`}
                    </button>}
                </div>
            </div>}
        </div>
    );
};
